import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-articles',
    templateUrl: './articles.component.html',
    styleUrls: ['./articles.component.scss'],
    imports:[RouterModule]
})
export class ArticlesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
